// extracted by mini-css-extract-plugin
export default {"imageWrapper":"GN-z","twoColumnImage":"HN-z"};